import { css } from "@emotion/css";
import { Checkbox, Callout } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React, { useMemo, useState } from "react";
import { session } from "~/clientInstance";
import FormComponent from "~/components/FormComponent/FormComponent";
import { Text } from "~/components/form";
export function ToggleControls() {
    const [newToggleName, setNewToggleName] = useState("");
    const featureToggleNames = useMemo(() => new Set<string>((session.featureToggles ?? []).map((toggle) => toggle.Name)), []);
    const [featureToggleOverrides, setFeatureToggleOverrides] = useState<Record<string, boolean>>(session.featureToggleOverrides);
    function setToggleState(name: string, enabled: boolean) {
        const newFeatureToggleOverrides = { ...featureToggleOverrides, [name]: enabled };
        setFeatureToggleOverrides(newFeatureToggleOverrides);
        session.setFeatureToggleOverrides(newFeatureToggleOverrides);
    }
    function addAvailableToggle() {
        if (newToggleName !== "") {
            if (featureToggleNames.has(newToggleName) || newToggleName in featureToggleOverrides) {
                return;
            }
            const newFeatureToggleOverrides = { ...featureToggleOverrides, [newToggleName]: true };
            setFeatureToggleOverrides(newFeatureToggleOverrides);
            session.setFeatureToggleOverrides(newFeatureToggleOverrides);
        }
    }
    function renderToggles() {
        const featureToggles: Array<[
            string,
            boolean
        ]> = (session.featureToggles ?? []).map(({ Name, IsEnabled }) => [Name, IsEnabled] as const);
        const newFeatureToggles: Array<[
            string,
            boolean
        ]> = Object.entries(featureToggleOverrides).filter(([name]) => !featureToggleNames.has(name));
        return newFeatureToggles
            .concat(featureToggles)
            .filter(([name]) => name.includes(newToggleName.trim()))
            .map(([name, isEnabled]) => <Checkbox key={name} label={name} value={featureToggleOverrides[name] ?? isEnabled} onChange={(enabled) => setToggleState(name, enabled)} noMargin/>);
    }
    return (<>
            <Callout hideTitle type={"warning"}>
                This only controls the toggle values in the UI (not the values on the Server)
            </Callout>
            <div className={styles.content}>
                <FormComponent onFormSubmit={() => addAvailableToggle()}>
                    <Text label={"Add toggle"} value={newToggleName} onChange={setNewToggleName} hideUnderline={true} autoFocus/>
                </FormComponent>
                {renderToggles()}
            </div>
        </>);
}
const styles = {
    content: css({
        display: "flex",
        flexDirection: "column",
        gap: space[4],
        padding: `${space[16]}`,
    }),
};
